import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-10 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "preview-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "preview-tab",
  tabindex: "0"
}
const _hoisted_5 = {
  class: "ratings",
  dir: "ltr"
}
const _hoisted_6 = ["onMouseover", "onClick"]
const _hoisted_7 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Interactive Rating", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star, index) => {
              return _createElementVNode("span", {
                key: index,
                class: "rating me-2",
                onMouseover: ($event: any) => (_ctx.hoverRating(index + 1)),
                onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hoverRating(0))),
                onClick: ($event: any) => (_ctx.setRating(index + 1))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(
                  index + 1 <= (_ctx.hoveredRating || _ctx.rating)
                    ? 'ri-star-fill'
                    : 'ri-star-line'
                )
                }, null, 2)
              ], 40, _hoisted_6)
            }), 64))
          ]),
          _createElementVNode("p", _hoisted_7, "Your Rating: " + _toDisplayString(_ctx.rating), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "tab-pane fade",
          id: "code-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "code-tab",
          tabindex: "0"
        }, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            "data-clipboard-target": "#basicAlertsCode"
          }, " Copy "),
          _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode"
            }, "\n<div class=\"ratings\" dir=\"ltr\">\n  <span\n    v-for=\"(star, index) in 5\"\n    :key=\"index\"\n    class=\"rating me-2\"\n    @mouseover=\"hoverRating(index + 1)\"\n    @mouseleave=\"hoverRating(0)\"\n    @click=\"setRating(index + 1)\"\n  >\n    <i\n      :class=\"index + 1 <= (hoveredRating || rating) ? 'ri-star-fill' : 'ri-star-line'\"\n    ></i>\n  </span>\n</div>\n"),
            _createTextVNode("\n")
          ])
        ], -1))
      ])
    ])
  ]))
}